import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'

export type StatusBannerTone = 'info' | 'warning' | 'danger'

interface StatusBannerProps {
  tone: StatusBannerTone
  action?: ReactNode
  className?: string
  children: ReactNode
}

const TONE_CLASSES: Record<StatusBannerTone, { box: string; icon: string }> = {
  info: { box: 'zocks-bg-color-gray-100 zocks-border-color-gray-200', icon: 'bi bi-info-circle zocks-text-gray-700' },
  warning: { box: 'zocks-bg-color-warning-background zocks-border-color-warning', icon: 'bi bi-exclamation-triangle-fill zocks-text-warning-dark' },
  danger: { box: 'zocks-bg-color-danger-background zocks-border-color-danger', icon: 'bi bi-exclamation-triangle-fill zocks-text-danger' },
}

export const StatusBanner: FC<StatusBannerProps> = ({ tone, action, className, children }) => (
  <div
    role='status'
    className={classNames(
      'd-flex align-items-center justify-content-between gap-3 px-3 py-2 border rounded-2 paragraph-small',
      TONE_CLASSES[tone].box,
      className,
    )}
  >
    <span className='d-flex align-items-center zocks-gap-0.5'>
      <i className={classNames(TONE_CLASSES[tone].icon, 'flex-shrink-0')} aria-hidden='true' />
      <span>{children}</span>
    </span>
    {action}
  </div>
)
